import { ReactNode } from 'react';

interface TripActionButtonProps {
  onClick: (e: React.MouseEvent) => void;
  icon: ReactNode;
  label: string;
  isPastTrip?: boolean;
  customClassName?: string;
}

export default function TripActionButton({
  onClick,
  icon,
  label,
  isPastTrip = false,
  customClassName = '',
}: TripActionButtonProps) {
  const baseClassName =
    'flex items-center justify-center flex-1 bg-gray-100 border border-gray-200 py-10pxr px-20pxr gap-8pxr rounded-6pxr';
  const pastTripClassName = isPastTrip ? 'border-new-point-500 text-new-point-500 bg-white' : '';

  return (
    <button className={`${baseClassName} ${pastTripClassName} ${customClassName}`} onClick={onClick}>
      {icon}
      <p className={`text-gray-800 button-14-m ${isPastTrip ? 'text-new-point-500' : ''}`}>{label}</p>
    </button>
  );
}
